//Interceptors
import { ErrorInterceptor } from "./error.interceptor";
import { AuthInterceptor } from "./auth.interceptor";

//Utilities
import { Newid } from "./util";

export const Helpers = { ErrorInterceptor, AuthInterceptor, Newid };
